export { MAX_PER_API_BATCH_SIZE as MAX_TABLE_SELECTION } from '@/utils/constants';

export const rowLimits = [5, 10, 20, 30, 40, 50];

export const getPaginationItems = (rowsPerPage = rowLimits[1]) =>
	rowLimits.map((item) => ({
		label: `${item} rows per page`,
		value: item,
		default: item === rowsPerPage,
	}));
